import { ToastAlertTypes } from '@genial/components';

export const productsDetailText = 'Veja mais detalhes\nsobre este produto';
export const defaultErrorMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao carregar o Portal,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];
